<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <p class="overline text-primary mb-1">FEATURED</p>
        <h3 class="typography-headline-sm">Our partner sites</h3>
      </div>
    </div>
    <div class="row mb-3">
      <!-- MENUFFY CTA TEXT SECTION -->
      <div class="col-md-12 col-lg-6 mb-3">
        <a href="https://menuffy.com/?ref=colorffy" rel="noopener" target="_blank">
          <div class="card card-outline card-cta translate-up">
            <div class="card-body d-flex justify-content-between flex-column">
              <div class="d-flex flex-wrap flex-lg-nowrap">
                <div class="align-self-center me-3">
                  <img src="@/assets/img/logos/products/menuffy-logo.svg" class="img-fluid mb-3" width="50px"
                       height="50px"
                       alt="Menuffy logo">
                </div>
                <div class="align-self-center">
                  <p class="subtitle-1 fw-500 mb-1">
                    Menuffy
                    <span class="badge badge-success px-3">
                      14-day trial
                    </span>
                  </p>
                  <p class="subtitle-1 text-muted">
                    Create your restaurant digital menu, use Menuffy to create and host unlimited digital/contactless
                    menus
                    and share it to your clients with QR codes.
                  </p>
                </div>
              </div>

              <div>
                <div class="badge badge-default-outline px-3">
                  For restaurants
                </div>
                <div class="badge badge-default-outline px-3">
                  QR codes generator
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>

      <!-- THEDOCS CTA TEXT SECTION -->
      <div class="col-md-12 col-lg-6 mb-5">
        <a href="https://the-docs.com/?ref=colorffy" rel="noopener" target="_blank">
          <div class="card card-outline card-cta translate-up">
            <div class="card-body d-flex justify-content-between flex-column">
              <div class="d-flex flex-wrap flex-lg-nowrap">
                <div class="align-self-center me-3">
                  <img src="@/assets/img/logos/products/thedocs-logo.svg" class="img-fluid mb-3" width="50px"
                       height="50px"
                       alt="TheDocs logo">
                </div>
                <div class="align-self-center">
                  <p class="subtitle-1 fw-500 mb-1">TheDocs
                    <span class="badge badge-success px-3">
                      Live now
                    </span>
                  </p>
                  <p class="subtitle-1 text-muted">
                    Create beautiful documentation sites.
                    See how beautifully simple your documentation site can be.
                  </p>
                </div>
              </div>

              <div>
                <div class="badge badge-default-outline px-3">
                  <span class="d-none d-xl-inline-block">Documentation</span>
                  <span class="d-inline-block d-xl-none">Docs</span>
                  sites builder
                </div>
                <div class="badge badge-default-outline px-3">
                  <span class="d-none d-xl-inline-block">Documentation</span>
                  <span class="d-inline-block d-xl-none">Docs</span>
                  versions
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectsCTA'
}
</script>